/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProjectDetailsTypeResource = {
    Short: 'SHORT',
    Recurring: 'RECURRING'
} as const;
export type ProjectDetailsTypeResource = typeof ProjectDetailsTypeResource[keyof typeof ProjectDetailsTypeResource];


export function instanceOfProjectDetailsTypeResource(value: any): boolean {
    for (const key in ProjectDetailsTypeResource) {
        if (Object.prototype.hasOwnProperty.call(ProjectDetailsTypeResource, key)) {
            // @ts-ignore
            if (ProjectDetailsTypeResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProjectDetailsTypeResourceFromJSON(json: any): ProjectDetailsTypeResource {
    return ProjectDetailsTypeResourceFromJSONTyped(json, false);
}

export function ProjectDetailsTypeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDetailsTypeResource {
    return json as ProjectDetailsTypeResource;
}

export function ProjectDetailsTypeResourceToJSON(value?: ProjectDetailsTypeResource | null): any {
    return value as any;
}

